<script>
    import FigureWidget from "./FigureWidget.svelte";
    import Gauge from "./Gauge.svelte";
    import Chart from "../Chart.svelte";

    export let data;
    export let config;
    export let loading = false;

    function formatDate(date) {
        const d = new Date(date);
        return d.toLocaleTimeString().replace(":00", "");
    }

    $: if (!!data) {
        data.charts.category.every((d) => (d.label = formatDate(d.label)));
    }

</script>

<div class="grid grid-cols-1 gap-5 mt-6 sm:grid-cols-2 lg:grid-cols-5">
    
    {#each config.topWidgets as widget}
        <FigureWidget
            title={widget.name}
            data={data?.widgets?.[widget.key] || null}
            type={widget.type}
            prefix={widget.prefix}
            suffix={widget.suffix}
            {loading}
        />
    {/each}
</div>
<div class="grid mt-6 grid-cols-3 lg:grid-cols-6 gap-4 place-content-between ">
    {#each config.charts as chart}
        <div
            class="dashboard-chart p-4 transition-shadow col-span-3 border rounded-lg shadow-sm hover:shadow-lg bg-white"
        >
            <Chart
                caption={chart.caption}
                type={chart.type}
                sNumberPrefix={chart.sNumberPrefix}
                category={data?.charts?.category || []}
                chartData={data?.charts?.[chart.key] || []}
                options={chart.options}
                {loading}
                theme={chart.theme}
            />
        </div>
    {/each}
    {#each config.widgets as widget}
        <Gauge
            title={widget.name}
            data={data?.widgets?.[widget.key]}
            {loading}
        />
    {/each}
</div>

<style>
    .dashboard-chart {
        min-height: 436px;
        position: relative;
    }
</style>
